export default __webpack_public_path__ + "locales/nl/Settings.json?hash=25373398da6777e09bbfb0e6441d347d";